export const filterConfig = [{
  id: 'LocalCidade',
  type: 'text',
  label: 'Cidade',
  placeholder: 'Digite a cidade'
}, {
  id: 'LocalEstado',
  type: 'text',
  label: 'Estado',
  placeholder: 'Digite o estado'
}, {
  id: 'Frota',
  type: 'text',
  label: 'Frota',
  placeholder: 'Digite a frota'
}, {
  id: 'Veiculo',
  type: 'text',
  label: 'Placa do Veículo',
  placeholder: 'Digite a placa'
}, {
  id: 'NomeMotorista',
  type: 'text',
  label: 'Nome do Motorista',
  placeholder: 'Digite o nome do motorista'
}, {
  id: 'NomeGestor',
  type: 'text',
  label: 'Nome do Gestor',
  placeholder: 'Digite o nome do gestor'
}, {
  id: 'NomeComercial',
  type: 'text',
  label: 'Nome Comercial',
  placeholder: 'Digite o nome comercial'
}, {
  id: 'Destino',
  type: 'text',
  label: 'Destino',
  placeholder: 'Digite o destino'
}, {
  id: 'Vazio',
  type: 'select',
  label: 'Vazio',
  placeholder: 'Selecione...',
  options: [{
    value: 'true',
    label: 'Sim'
  }, {
    value: 'false',
    label: 'Não'
  }]
}, {
  id: 'Coleta',
  type: 'select',
  label: 'Coleta',
  placeholder: 'Selecione...',
  options: [{
    value: 'true',
    label: 'Sim'
  }, {
    value: 'false',
    label: 'Não'
  }],
  defaultValue: 'false'
}, {
  id: 'Negociacao',
  type: 'select',
  label: 'Negociação',
  placeholder: 'Selecione...',
  options: [{
    value: 'true',
    label: 'Sim'
  }, {
    value: 'false',
    label: 'Não'
  }]
}, {
  id: 'DescargaPendente',
  type: 'select',
  label: 'Desc. Pendente',
  placeholder: 'Selecione...',
  options: [{
    value: 'true',
    label: 'Sim'
  }, {
    value: 'false',
    label: 'Não'
  }]
}];
